import React, { useState } from 'react';
import { IconButton, Drawer, List, ListItem, ListItemText } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Div, Text } from 'view/lib/components';
import { Page } from 'services/models';
import { Book, DocumentScanner, Height, Home, HomeRepairService, Info, SupportAgent } from '@mui/icons-material';
import Button from '../button';

interface Props {
  readonly setPage: (page: Page) => void;
  readonly page: Page;
}

function Header({ page, setPage }: Props) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open: boolean) => (event: React.TouchEvent | React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === 'keydown' &&
       ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')) {
      return;
    }
    setDrawerOpen(prev => open);
  };

  const menuItems = [
    { icon: <Home />, text: "Home", page: Page.Home },
    { icon: <HomeRepairService />, text: "Services", page: Page.Services },
    { icon: <Info />, text: "About", page: Page.About },
    { icon: <DocumentScanner />, text: "Portfolio", page: Page.Portfolio },
    // { icon: <Book />, text: "Blog", page: Page.Blog },
    { icon: <SupportAgent />, text: "Contact", page: Page.Contact }
  ];

  return (
    <Div id="header" style={styles.container}>
      <Div style={styles.headerContainer}>
        <Text style={styles.text}>RG</Text>
        <Div style={styles.icon}>
          <IconButton color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
            <MenuIcon />
          </IconButton>
        </Div>
        <Div style={styles.menu}>
          {menuItems.map((item) =>
            <Button
              key={item.text}
              style={{...styles.menuItem, color: page === item.page ? "tomato" : "black"}}
              onClick={() => setPage(item.page)}>
              <Text>{item.text}</Text>
            </Button>
          )}
        </Div>
      </Div>
      <Drawer open={drawerOpen} onClose={toggleDrawer(false)}>
        <List style={styles.list}>
          <Text style={{...styles.text, marginLeft: "5%"}}>Ruturaj Gole</Text>
          <hr />
          {menuItems.map((item, index) => (
            <ListItem
              style={{
                cursor: "pointer",
                backgroundColor: page === item.page ? "#9574bd" : "lavender",
              }}
              key={index}
              onClick={(e) => {
              toggleDrawer(false)(e);
              setPage(item.page);
            }}>
              {item.icon}
              <ListItemText style={{ 
                color: page === item.page ? "white" : "black",
              }} primary={item.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </Div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    position: "sticky",
    width: "100%",
    top: 0,
    zIndex: "1",
    background: "lavender"
  },
  menuItem: {
    margin: "0% 1%"
  },
  menu: {
    display: ["none", "none", "flex"]
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "4%",
    backgroundColor: "lavender"
  },
  icon: {
    display: ["block", "block", "none"]
  },
  list: {
    backgroundColor: "lavender",
    width: "80vw",
    height: "100vh"
  },
  text: {
    fontWeight: "bold",
    fontSize: "large"
  }
};

export default Header;
